import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import GestionLegal from "./GestionLegal";
import icon from "../../../assets/static/images/secciones/gestionlegal.png";
import { connect, useDispatch } from "react-redux";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import { getComercios } from "../../../redux/Sections/Comercios/actions";
import { getInmuebles, setInmuebles } from "../../../redux/Sections/Inmuebles/actions";
import ArrowBack from "../../../components/ArrowBack";
import { deudasService } from "../../../_services/deudas.service";
import { v4 as uuidv4 } from "uuid";
import { useUser } from "../../../hooks/useUser";
import { inmuebleService } from "../../../_services/inmuebles.service";
import { setLoading } from "../../../redux/Loading/actions";

const GestionLegalPanel = ({ inmuebles, getComercios, comercios }) => {
  const dispatch = useDispatch();
  const user = useUser();
  const params = new URLSearchParams(location.search);
  const tipo = params.get("tipo");
  const historico = params.get("historico");
  const abogado = params.get("abogado");
  const [key, setKey] = useState(tipo || "inmuebles");

  useEffect(() => {
    setKey(tipo);
  }, [tipo]);

  const handleKey = (e) => {
    setKey(e);
  };

  const getData = async (data) => {
    if (key === "inmuebles") {
      if (data.imponible) {
        let body = {};

        // if (data.abogado) {
        //   body.abogado = data.abogado;
        // }
        if (data.nombre) {
          body.nombre = data.nombre;
        }
        if (data.imponible) {
          body.inmueble = data.imponible;
        }

        dispatch(setLoading(true));
        const resInmuebles = await inmuebleService.getInmuebles(body);
        dispatch(setLoading(false));

        if (resInmuebles?.length) {
          dispatch(setInmuebles(resInmuebles));
        }
        else {
          const recursos = ["AB", "SS", "RV"];
          let inmuebles = [];

          dispatch(setLoading(true));
          for (const recurso of recursos) {
            const res = await deudasService.listaSitua({
              imponible: data.imponible,
              recurso,
            }).then(res => res.situacion);

            if (res?.length) {
              inmuebles = [...inmuebles, ...res];
            }
          }
          dispatch(setLoading(false));
          if (inmuebles?.length) {
            const result = inmuebles.reduce((prev, current, i) => {
              if (prev.some((e) => e.NRO_IMPONIBLE === current.NRO_IMPONIBLE && e.RECURSO === current.RECURSO)) {
                return prev;
              } else {
                return [
                  ...prev,
                  {
                    ...current,
                    id: i,
                    uuid: uuidv4(),
                    RECURSO: current.RECURSO,
                    NRO_INMUEBLE: current.NRO_IMPONIBLE,
                    abogado: `${user.apellido} ${user.nombre} (${user.abogado})`,
                    codexterno: abogado,
                    recurso: current.RECURSO,
                    imponible: current.NRO_IMPONIBLE,
                    DOMICILIO: "-",
                    BARRIO: "-",
                    NOMENCLATURA: "-",
                    PARTIDA: "-",
                  }];
              }
            }, []);

            dispatch(setInmuebles(result));
          } else {
            dispatch(setInmuebles([]));
          }
        }
      }
      else if (data.nombre) {
        let body = {};

        if (data.abogado) {
          body.abogado = data.abogado;
        }
        if (data.nombre) {
          body.nombre = data.nombre;
        }
        if (data.imponible) {
          body.inmueble = data.imponible;
        }

        dispatch(setLoading(true));
        const resInmuebles = await inmuebleService.getInmuebles(body);
        dispatch(setLoading(false));

        dispatch(setInmuebles(resInmuebles));
      }
      else {
        dispatch(setLoading(true));
        const resInmuebles = await deudasService.listaSitua({
          abogado: data.abogado,
        }).then(res => res.situacion);
        dispatch(setLoading(false));

        const result = resInmuebles.reduce((prev, current, i) => {
          if (prev.some((e) => e.NRO_IMPONIBLE === current.NRO_IMPONIBLE && e.RECURSO === current.RECURSO)) {
            return prev;
          } else {
            return [
              ...prev,
              {
                ...current,
                id: i,
                uuid: uuidv4(),
                RECURSO: current.RECURSO,
                NRO_INMUEBLE: current.NRO_IMPONIBLE,
                abogado: `${user.apellido} ${user.nombre} (${user.abogado})`,
                codexterno: abogado,
                recurso: current.RECURSO,
                imponible: current.NRO_IMPONIBLE,
                DOMICILIO: "-",
                BARRIO: "-",
                NOMENCLATURA: "-",
                PARTIDA: "-",
              }];
          }
        }, []);

        dispatch(setInmuebles(result));
      }
    } else {
      getComercios(data);
    }
  };

  return (
    <div style={{ padding: 50 }}>
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="gestion-legal" />
        {
          historico ? <span>Historico</span> : <span>Gestión Legal</span>
        }
      </div>
      <ArrowBack />

      <div className="mt-5">
        <Tabs
          activeKey={key}
          onSelect={handleKey}
        >
          <Tab eventKey="inmuebles" title="Inmuebles">
            {key === "inmuebles" && <GestionLegal type="inmuebles" action={getData} data={inmuebles} />}
          </Tab>
          <Tab eventKey="comercios" title="Comercios">
            {key === "comercios" && <GestionLegal type="comercios" action={getData} data={comercios} />}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    comercios: state.dashboard.comerciosList,
    inmuebles: state.dashboard.inmueblesList,
    abogados: state.dashboard.abogadosList,
    loading: state.dashboard.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAbogados: () => dispatch(getAbogados()),
    getComercios: (e) => dispatch(getComercios(e)),
    getInmuebles: (e) => dispatch(getInmuebles(e)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GestionLegalPanel);
